/**
 * Client for the gateway's search (/v2/find), the same search deepick mini uses: organizations,
 * publications and documents, a document's text and its original file. Same-origin, so the
 * browser's session cookie authenticates.
 */
async function get(path) {
  const res = await fetch(path, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(body.error || `Suche nicht verfügbar (${res.status})`);
    err.status = res.status;
    throw err;
  }
  return body;
}

/** A query string; an array value repeats its parameter. */
const qs = (params) =>
  Object.entries(params)
    .flatMap(([k, v]) => (Array.isArray(v) ? v.map((x) => [k, x]) : [[k, v]]))
    .filter(([, v]) => v !== undefined && v !== null && v !== '')
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join('&');

export const find = (params) => get(`/v2/find?${qs(params)}`);
/** The organization network over a document search, with the same parameters: {fileRows, roleRows, mentionRows, truncated, …}. */
export const findNetwork = (params) => get(`/v2/find/network?${qs(params)}`);
export const suggest = (q) => get(`/v2/find/suggest?${qs({ q })}`);
export const findDocument = (id, q, offset = 0) => get(`/v2/find/documents/${encodeURIComponent(id)}?${qs({ q, offset })}`);
export const fileUrl = (id, download) => `/v2/find/files/${encodeURIComponent(id)}${download ? '?download=1' : ''}`;

/** The id in /dokument/:id and /v2/find paths: the UUID of a urn:uuid, any other IRI base64url-encoded. */
export const toId = (iri) =>
  iri.startsWith('urn:uuid:')
    ? iri.slice(9)
    : btoa(unescape(encodeURIComponent(iri))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');

/** dive's page of an organization: contracting bodies under /auftraggeber, everyone else under /bieter. */
export const organizationPath = (iri, mainType) => `/${mainType === 'AG' ? 'auftraggeber' : 'bieter'}/${String(iri).replace('urn:uuid:', '')}`;

/** dive's page of a publication. */
export const publicationPath = (iri) => `/publication?id=${encodeURIComponent(iri.substr(iri.indexOf('/kerndaten')))}`;

/**
 * The new search runs on the test site (and in local development) until the switch weekend of
 * 2026-11-07, when dive.deepick.eu gets it too; production keeps the organization search bar.
 */
export const newSearch = () => ['dive-test.deepick.eu', 'localhost', '127.0.0.1'].includes(window.location.hostname);
